import { Component, Input, AfterContentChecked } from '@angular/core';
import { NavController, ToastController } from 'ionic-angular';
import {
  INICIO_PAGE,
  NOSOTROS_PAGE,
  CONTACTO_PAGE,
  UNETE_PAGE,
  PERFIL_PAGE,
  ACCESO_PAGE,
  BURGER_TOK_CHALLENGE, DELIVERY_PAGE, ENVIO_A_DOMICILIO, ENVIO_PICK_UP
} from '../../pages/pages.constants';
import { Api } from '../../providers';
import {MarcaYRecogePage} from "../../pages/marca-y-recoge/marca-y-recoge";

@Component({
  selector: 'header',
  templateUrl: 'header.html'
})
export class HeaderComponent implements AfterContentChecked {
  pages: any[] = [
    // {
    //   title: 'Inicio',
    //   component: INICIO_PAGE
    // },
    {
      title: 'Nosotros',
      component: NOSOTROS_PAGE
    },
    {
      title: 'Únete',
      component: UNETE_PAGE
    }, {
      title: 'Sucursales',
      component: ENVIO_PICK_UP
    }
  ];
  @Input('absolute') absolute: boolean;
  estaLogueado: boolean = false;

  constructor(
    private _nav: NavController,
    private _toast: ToastController,
    private _api: Api
  ) {
    if (!this.absolute) this.absolute = true;
    this.estaLogueado = this._api.estaLogueado;
  }

  ngAfterContentChecked(): void {
    this.estaLogueado = this._api.estaLogueado;
  }

  openPage(page) {
    this._nav.setRoot(page.component);
  }

  abrirPerfil() {
    this._nav.setRoot(PERFIL_PAGE).then(val => {
      if (val === false) {
        this._nav.setRoot(ACCESO_PAGE);
      }
    });
  }

  tieneCarrito() {
    return true;
  }

  abrirCarrito() {
    this._toast
      .create({
        message: 'No tienes ningún alimento agregado a tu carrito.',
        duration: 3000,
        cssClass: 'info'
      })
      .present();
  }
}



// WEBPACK FOOTER //
// ./src/components/header/header.ts